import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { planColumn } from '../utils';
export default {
  props: ['visible', 'data'],
  data() {
    return {
      columns: planColumn,
      showData: []
    };
  },
  watch: {
    visible(newV) {
      if (newV) {
        this.getDetail(this.data);
      }
    }
    // data: {
    //   handler(newV) {
    //     if (newV && this.visible) {
    //       this.getDetail(newV);
    //     }
    //   },
    //   deep: true
    // }
  },
  methods: {
    async getDetail(data) {
      this.showData = [];
      data.map(item => {
        var _item$rightsCont;
        if ((_item$rightsCont = item.rightsCont) !== null && _item$rightsCont !== void 0 && _item$rightsCont.length) {
          // item.rights = JSON.parse(item.rights);
          item.rightsCont.map((val, index) => {
            let obj = {
              name: item.name,
              amount: item.amount,
              rightsName: val.name,
              rightsValue: val.value,
              rightsInfo: val.info
            };
            if (index == 0) {
              var _item$rightsCont2;
              obj.rowSpan = (_item$rightsCont2 = item.rightsCont) === null || _item$rightsCont2 === void 0 ? void 0 : _item$rightsCont2.length;
            } else {
              obj.rowSpan = 0;
            }
            this.showData.push(obj);
          });
        }
      });
    }
  }
};